<template>
  <div class="container">
    <div class="row">
      <div class="mb-3">
        <a
          v-if="!AddMode"
          class="d-inline float-right mx-2 mt-1"
          href="javascript:;"
          @click="
            AddMode = !AddMode
            addnew()
          "
          title="افزودن آدرس جدید"
        >
          <h4><i class="fas fa-plus text-success" style="color: var(--logo-color) !important"></i></h4>
        </a>
        <a v-if="AddMode" class="d-inline float-right mx-2 mt-1" href="javascript:;" @click="AddMode = !AddMode" title="لغو افزودن">
          <h4><i class="fas fa-times text-danger"></i></h4>
        </a>
      </div>
      <div v-if="Address.length < 1 && !AddMode" class="col-12 p-4 border Rounded">
        <h4>آدرسی ثبت نشده است.</h4>
      </div>
      <div v-if="AddMode" class="col-12" id="AddAdress">
        <div class="row">
          <div class="col-md-3 col-12">
            <small :id="'Lbl' + 'tblCombogrp10state'"> استــان </small>
            <SearchableCombo
              :edit="false"
              :grp="10"
              :code="null"
              @ResultCombo="GetResultState"
              :rownumintable="3"
              :defaultvalue="this.DataAxios.ArryfildValue.tblCombogrp10state"
              :action="'TblCrmCombo/GetComboById'"
              :method="'POST'"
              :idinput="'State'"
              :keyItem="'State'"
              :ClassProps="'required'"
              :disabled="false"
            >
            </SearchableCombo>
          </div>
          <div class="col-md-3 col-12">
            <small :id="'Lbl' + 'tblCombogrp11Shahr'"> شـهر </small>
            <SearchableCombo
              v-if="rendergrid"
              :edit="false"
              :grp="11"
              :code="DataAxios.ArryfildValue.tblCombogrp10state"
              @ResultCombo="GetResultCity"
              :rownumintable="3"
              :defaultvalue="DataAxios.ArryfildValue.tblCombogrp11Shahr"
              :action="'TblCrmCombo/GetComboByParentId'"
              :method="'POST'"
              :idinput="'City'"
              :keyItem="'City'"
              :ClassProps="'required'"
              :disabled="DataAxios.ArryfildValue.tblCombogrp10state == 0"
            >
            </SearchableCombo>
          </div>
          <div class="col-md-6 col-12">
            <small :id="'Lbl' + 'tblComboGrpId57TypeAddres'"> نوع آدرس </small>
           <SearchableCombo
                v-if="$store.state.renderComponentCombo"
                :edit="false"
                :grp="57"
                :code="null"
                @ResultCombo="ResultGrp57TypeAddres"
                :rownumintable="3"
                :defaultvalue="DataAxios.ArryfildValue.tblComboGrpId57AddresType?DataAxios.ArryfildValue.tblComboGrpId57AddresType:2003"
                :action="'TblCrmCombo/GetComboById'"
                :method="'POST'"
                :idinput="'Grp'"
                :keyItem="'Grp'"
                :disabled="false"
                :ClassProps="'required Pointer'"
              >
            </SearchableCombo>
          </div>
          <div class="col-12 mb-2">
            <small :id="'Lbl' + 'Adress'"> آدرس </small>
            <input type="text" :id="'Adress'" class="form-control" placeholder="آدرس" v-model="DataAxios.ArryfildValue.Adress" />
          </div>
          <div class="col-md-3 col-12 mt-2">
            <small :id="'Lbl' + 'Tel'"> تلفن </small>
            <input :id="'Tel'" type="tel" class="form-control text-left" dir="ltr" v-model="DataAxios.ArryfildValue.Tel" />
          </div>
          <div class="col-md-3 col-12">
            <small :id="'Lbl' + 'Fax'"> فکس </small>
            <input :id="'Fax'" type="tel" class="form-control text-left" dir="ltr" v-model="DataAxios.ArryfildValue.Fax" />
          </div>
          <div class="col-md-3 col-12">
            <small :id="'Lbl' + 'Email'"> ایمیل </small>
            <input :id="'Email'" type="email" class="form-control text-left" dir="ltr" v-model="DataAxios.ArryfildValue.Email" />
          </div>
          <div class="col-md-3 col-12">
            <small :id="'Lbl' + 'CodePosti'"> کد پستی </small>
            <input :id="'CodePosti'" type="number" class="form-control text-left" dir="ltr" v-model="DataAxios.ArryfildValue.CodePosti" />
          </div>
          <div class="col-md-3 col-12 pt-4">
            <small :id="'Lbl' + 'Asli'"> </small>
            <div class="custom-control custom-switch">
              <input :id="'Asli'" type="checkbox" class="custom-control-input InputText" v-model="DataAxios.ArryfildValue.Asli" />
              <label class="custom-control-label" :for="'Asli'">اصلی</label>
            </div>
          </div>
          <div class="col-md-8 mt-4 col-12"></div>
          <div class="col-md-4 mt-4 col-12">
            <button v-if="status == 'add'" @click="submitAddress" class="btn btn-success w-100">ثبت آدرس <i class="fad fa-check"></i></button>
            <button v-if="status == 'edit'" @click="EditAddress" class="btn btn-warning w-100">اصلاح آدرس <i class="fad fa-check"></i></button>
          </div>
        </div>
      </div>
      <div v-if="Address.length > 0 && !AddMode" class="col-12">
        <div class="row">
          <div v-for="(address, index) in Address" :key="index" class="col-md-4 col-12 p-2">
            <CardBox>
              <template v-slot:cardbox-icon1><i class="fad fa-car-building"></i></template>
              <template v-slot:b-dropdown-item>
                <b-dropdown-item @click="Edit(address)" href="#" class="text-center">ویرایش</b-dropdown-item>
                <b-dropdown-item @click="DeleteQuestion(address)" href="#" class="text-center">حذف</b-dropdown-item>
              </template>
              <template v-slot:cardbox-body>
                <h5 class="text-warning">{{address.TypeAddres}}</h5>
                <p class="card-title text-center"><span>آدرس: </span> {{ address.State }} - {{ address.City }} - {{ address.Adress }}</p>
                <!-- <p class="card-text detail mt-4"> سمت : {{person.tblcomboGrp1SematName}}</p> -->
                <p class="card-text detail"><i class="fad fa-phone"></i> تلفن : {{ address.Tel }}</p>
                <p class="card-text detail"><i class="fad fa-at"></i> کد پستی : {{ address.CodePosti }}</p>
                <!-- <p v-if="person.SendSmsTo && person.SendSmsTo!=false" class="card-text detail text-info">امکان ارسال پیامک</p> -->
              </template>
            </CardBox>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'
import CardBox from '@/components/CardBox/CardBox.vue'

export default {
  props: ['CustomerId', 'AdressList'],
  data() {
    return {
      AddMode: false,
      Address: [],
      NewAddress: {
        Id: 77,
        tblCombogrp11Shahr: null,
        tblCombogrp10state: null,
        tblCustomerId: this.CustomerId,
        Asli: false,
        Adress: '',
        Tel: '',
        Fax: '',
        Email: '',
        TblUserGrpIdInsert: this.$session.get('UserInfo').tblUserGrpId,
      },
      DataAxios: {
        Action: 'TblCustomerAddress/Add',
        Method: 'Post',
        ArryfildValue: {},
      },
      rendergrid: true,
    }
  },

  methods: {
    addnew() {
      this.DataAxios.ArryfildValue = JSON.parse(JSON.stringify(this.NewAddress))
      this.status = 'add'
    },
    GetResultState(data) {
      var index = Number(data.key.replace('State', ''))
      this.DataAxios.ArryfildValue.tblCombogrp10state = data.id
      this.rendergrid = false
      this.$nextTick(() => {
        this.rendergrid = true
      })
    },
    GetResultCity(data) {
      var index = Number(data.key.replace('City', ''))
      this.DataAxios.ArryfildValue.tblCombogrp11Shahr = data.id
    },
    submitAddress() {
      if (this.$ValidForm('AddAdress')) {
        this.$PostData(this.DataAxios).then((result) => {
          if (result.status == 'success') {
            this.AddMode = false
            this.$mySweetDefaultTost('عملیات موفق', 'آدرس جدید با موفقیت ثبت شد', 'success', 2000)
            this.$emit('Inserted', {
              done: 'OK',
              activeTab: 2,
            })
          }
        })
      }
    },
    Edit(data) {
      this.status = 'edit'
      data.TblUserGrpIdLastEdit = this.$session.get('UserInfo').tblUserGrpId
      this.DataAxios.ArryfildValue = JSON.parse(JSON.stringify(data))
      this.$store.state.OldDataForLog = JSON.stringify(data)
      this.AddMode = true
    },
    EditAddress() {
      var DataAxiosEdit = JSON.parse(JSON.stringify(this.DataAxios))
      DataAxiosEdit.Method = 'PUT'
      DataAxiosEdit.Action = 'TblCustomerAddress/Edit'
      if (this.$ValidForm('AddAdress')) {
        this.$PostData(DataAxiosEdit).then((result) => {
          if (result.status == 'success') {
            this.AddMode = false
            this.$mySweetDefaultTost('عملیات موفق', 'آدرس  با موفقیت اصلاح شد', 'success', 2000)
            this.$SetLog(DataAxiosEdit.ArryfildValue, 0, 0, 'Address', 'آدرس')
            this.$emit('Inserted', {
              done: 'OK',
              activeTab: 2,
            })
          }
        })
      }
    },
    DeleteAddress(data) {
      this.$store.state.OldDataForLog = JSON.stringify(data)
      var DataAxiosEdit = {
        Action: 'TblCustomerAddress/Delete',
        Method: 'Delete',
        ArryfildValue: {
          id: JSON.parse(JSON.stringify(data.Id)),
        },
      }

      this.$PostData(DataAxiosEdit).then((result) => {
        if (result.status == 'success') {
          this.AddMode = false
          this.$mySweetDefaultTost('عملیات موفق', 'آدرس  با موفقیت اصلاح شد', 'success', 2000)
          this.$SetLog(DataAxiosEdit.ArryfildValue, 1, 0, 'Address', 'آدرس')

          this.$emit('Inserted', {
            done: 'OK',
            activeTab: 2,
          })
        }
      })
    },
    DeleteQuestion(data) {
      this.$SweetQustion('هشدار', 'ایا از حذف ادرس اطمینان دارید؟', 'info', 'بله', 'انصراف', data, this.DeleteAddress, this.cancel)
    },
    cancel() {},
    ResultGrp57TypeAddres(val){
      this.DataAxios.ArryfildValue.tblComboGrpId57AddresType=val.id
    }
  },
  created() {
    this.Address = this.AdressList
    this.Address.forEach((e) => {
      e.CodePosti = Number(e.CodePosti)
    })
  },
  components: { SearchableCombo, CardBox},
}
</script>
